import { memo } from "react";
import VideoTag from "./players/videoTag";
import { IPlayerCoreProps } from "interfaces";
import useWatchingDuration from "helpers/hooks/useWatchingDuration";


const PlayerCore = ({ isMultiLive }: IPlayerCoreProps) => {

    useWatchingDuration();

    return (
        <>
            <VideoTag isMultiLive={isMultiLive} />
        </>
    );
}

export default memo(PlayerCore);